import {
  BackgroundContainer,
  BlockContainer,
  BlockWrapper,
  TitleWrapper,
  VideoContainer
} from "./styles";
import { FC } from "react";
import { Block, Box, Image } from "../../../styles/basicStyles";
import { colors } from "../../../styles/colors";
import Typography from "../../../components/typography";
import dynamic from "next/dynamic";
import Fade from "react-reveal/Fade";
const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });

interface BlocksProps {
  type: number;
  blockBarColor?: string;
  title?: string;
  description?: string;
  image?: string;
  bgColor?: string;
  position?: number;
  orientation?: number;
  animation?: string;
  video?: string;
  maxWidth?: number;
  paddingBottom?: boolean;
  paddingTop?: boolean;
}

const Blocks: FC<BlocksProps> = ({
  type,
  blockBarColor,
  title,
  description,
  image,
  bgColor,
  position,
  orientation,
  animation,
  video,
  maxWidth,
  paddingBottom,
  paddingTop
}) => {
  return (
    <Box mt={1.563} mb={1.563}>
      {
        type === 1 ?
        <BlockContainer>
          <BlockWrapper
            mt={2.5}
            mb={1.563}
            fDirection={{ md: "row", xxs: "column" }}
          >
            <Block w={{ md: "30%", xxs: "100%" }}>
              {
                title &&
                <Fade left>
                  <TitleWrapper barColor={blockBarColor} mr={{ md: 1.5, xxs: 0 }}>
                    <Typography
                      fSize={{ md: 1.875, xxs: 1.5 }}
                      lHeight={{ md: 1.938, xxs: 2 }}
                      fWeight={700}
                      style={{ color: colors.black }}
                    >
                      {title}
                    </Typography>
                  </TitleWrapper>
                </Fade>
              }
            </Block>
            <Box mt={{ md: 0, xxs: 1.5 }} w={{ md: "70%", xxs: "100%" }}>
              {
                description &&
                <Fade right>
                  <Typography
                    fSize={1.125}
                    lHeight={1.75}
                    fWeight={400}
                    style={{ color: colors.black }}
                    dangerouslySetInnerHTML={{ __html: description?.replace(/<p><\/p>/g, '<p>&nbsp;</p>') }}
                  />
                </Fade>
              }
            </Box>
          </BlockWrapper>
        </BlockContainer>
        : 
        type === 2 ?
        <BackgroundContainer
          position="relative"
          background={position === 3 ? bgColor : undefined}
        >
          <BlockContainer w="100%" zIndex={1} fJustify="center" fAlign="center">
            <Fade bottom>
              <Image
                loading='lazy'
                src={image}
                maxW="100%"
                pt={paddingTop ? 4.375 : 0}
                pb={paddingBottom ? 4.375 : 0}
                alt='content image'
              />
            </Fade>
          </BlockContainer>
          {
            (position === 1 || position === 2) &&
            <Block
              w="100%"
              h={position === 1 || position === 2 ? "75%" : "100%"}
              bottom={position === 1 ? -1.563 : undefined}
              top={position === 2 ? -1.563 : undefined}
              bgColor={bgColor ? bgColor : undefined}
              position={position === 1 || position === 2 ? "absolute" : undefined}
            />
          }
        </BackgroundContainer>
        : 
        type === 3 ?
        <BlockContainer>
          <BlockWrapper
            mt={2.5}
            mb={1.563}
            fDirection={{ md: "row", xxs: "column" }}
          >
            <Box display={{ md: orientation === 2 ? "flex" : "none", xxs: "none" }}>
              <Fade left>
                <Image 
                  loading='lazy'
                  src={image} 
                  maxW="100%" 
                  pr={{ md: 2.188, xxs: 0 }} 
                  alt='content image' 
                />
              </Fade>
            </Box>
            <Fade left={orientation === 1} right={orientation === 2}>
              <Box fDirection="column">
                {
                  title &&
                  <TitleWrapper
                    barColor={blockBarColor}
                    mr={{ md: 1.5, xxs: 0 }}
                    mb={1.875}
                  >
                    <Typography
                      fSize={{ md: 1.875, xxs: 1.5 }}
                      lHeight={{ md: 1.938, xxs: 2 }}
                      fWeight={700}
                      style={{ color: colors.black }}
                    >
                      {title}
                    </Typography>
                  </TitleWrapper>
                }
                <Typography
                  fSize={1.125}
                  lHeight={1.75}
                  fWeight={400}
                  style={{ color: colors.black }}
                  dangerouslySetInnerHTML={{ __html: description?.replace(/<p><\/p>/g, '<p>&nbsp;</p>') }}
                />
              </Box>
            </Fade>
            <Box
              mt={{ md: 0, xxs: 1.25 }}
              display={{ md: orientation === 1 ? "flex" : "none", xxs: "flex" }}
            >
              <Fade right>
                <Image 
                  loading='lazy'
                  src={image} 
                  maxW="100%" 
                  pl={{ md: 2.188, xxs: 0 }} 
                  alt='content image'
                />
              </Fade>
            </Box>
          </BlockWrapper>
        </BlockContainer>
        : 
        type === 4 ?
        <BlockContainer display="flex" w="100%" fJustify="center">
          <Fade bottom>
            <Image 
              loading='lazy'
              src={animation} 
              maxW={{ md: 50, xxs: "100%" }} 
              alt='content animation' 
            />
          </Fade>
        </BlockContainer>
        : 
        type === 5 ?
        <BackgroundContainer background={bgColor ? bgColor : undefined}>
          <BlockContainer display="flex" w="100%" fJustify="center">
            <Fade bottom>
              <VideoContainer pt={1.563} pb={1.563} maxWidth={maxWidth}>
                <ReactPlayer url={video} controls width="100%" height="auto" />
              </VideoContainer>
            </Fade>
          </BlockContainer>
        </BackgroundContainer>
        : 
        null
      }
    </Box>
  );
};

export default Blocks;
